import React from "react";
import { FaBook, FaUserGraduate, FaStar, FaPercent, FaHandsHelping, FaLightbulb } from "react-icons/fa";

const benefits = [
  { icon: <FaBook />, text: "1 Free eBook/Book Publishing with ISBN" },
  { icon: <FaUserGraduate />, text: "2 Research Papers/Articles Published" },
  { icon: <FaStar />, text: "Access to 1000+ Digital Library Resources" },
  { icon: <FaPercent />, text: "25% Discount on Book Purchases" },
  { icon: <FaHandsHelping />, text: "Life Guidance via Numerology & Astrology" },
  { icon: <FaLightbulb />, text: "Consultations, Rituals & Personal Advice" },
];

const MembershipBenefits = () => (
  <div className="benefits-section">
    <h2>Membership Benefits</h2>
    <ul>
      {benefits.map((b, idx) => (
        <li key={idx}>
          <span className="benefit-icon">{b.icon}</span> {b.text}
        </li>
      ))}
    </ul>
  </div>
);

export default MembershipBenefits;
